<!--
 * @Author: chj
 * @Date: 2024-10-10 12:39:45
 * @LastEditors: chj
 * @LastEditTime: 2024-11-06 16:34:56
 * @Description: 请填写简介
-->
<template>
  <div :class="bem()">
    <carousel />
    <div :class="bem('container')">
      <h2 :class="bem('title')">联盟简介</h2>
      <section-item
        v-for="(section, index) in sectionList"
        :key="index"
        :direction="index % 2 == 0 ? 'left' : 'right'"
        :title="section.data_title"
        :content="section.subheading"
        :img="section.thumb"
      />
      <article-list />
      <!-- <week-list /> -->
      <member />
    </div>
  </div>
</template>

<script>
import Carousel from "./components/Carousel.vue";
import Member from "./components/Member.vue";
import ArticleList from "./components/ArticleList.vue";
import SectionItem from "./components/SectionItem.vue";
import WeekList from "./components/WeekList.vue";
import { getDynamic } from "@/api/cms/dynamic";

export default {
  name: "home-view",
  components: {
    Carousel,
    Member,
    ArticleList,
    WeekList,
    SectionItem,
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        type: 8,
        pageSize: 100,
      },
      sectionList: [],
    };
  },
  methods: {
    async initData() {
      try {
        const res = await getDynamic(this.queryParams);
        if (res.code == 0) {
          const [item] = res.data.list;
          this.sectionList = [item];
        }
      } catch (err) {
        console.log("err", err);
      }
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.home-view {
  width: 100%;
  margin: 0 auto;
  &__container {
    width: 1440px;
    margin: 0 auto;
    @include devices(laptop) {
      width: 100%;
    }
  }
  &__title {
    margin: 40px auto;
    text-align: center;
    font-size: 48px;
    font-weight: 400;
    color: #000;
    line-height: 71px;
    @include devices(phone) {
      font-size: 28px;
      line-height: 44px;
    }
    span {
      color: rgba(250, 107, 50, 1);
    }
  }
}
</style>
